/*jshint esversion: 6 */
EBContext.data.session = EBContext.data.session || {};
EBContext.modules.SessionUtils = function (options) {
	var self = this;
	var languagePrefix = EBContext.data.languageUrl || '';
	this.options = {
		keepAlive: {
			refreshTimeout: 60000,
			refreshCount: 120,
			rootPath: '/',
			callback: null
		},
		productWrapSelector: '.product',
		statusClassActive: 'active',
		statusUpdate: function (type, oid, state) {
			var i;
			var statusEl = document.querySelectorAll(self.options.productWrapSelector + '[data-good-oid' + (oid === '*' ? '' : '="' + oid + '"') + '] .status-' + type);
			for (i = 0; i < statusEl.length; i++) {
				if (state) {
					statusEl[i].classList.add(self.options.statusClassActive);
				} else {
					statusEl[i].classList.remove(self.options.statusClassActive);
				}
			}
			var addEl = document.querySelectorAll(self.options.productWrapSelector + '[data-good-oid' + (oid === '*' ? '' : '="' + oid + '"') + '] .' + type + '-add');
			for (i = 0; i < addEl.length; i++) {
				if (state) {
					addEl[i].style.display = 'none';
				} else {
					addEl[i].style.display = '';
				}
			}
			var removeEl = document.querySelectorAll(self.options.productWrapSelector + '[data-good-oid' + (oid === '*' ? '' : '="' + oid + '"') + '] .' + type + '-remove');
			for (i = 0; i < removeEl.length; i++) {
				if (state) {
					removeEl[i].style.display = '';
				} else {
					removeEl[i].style.display = 'none';
				}
			}
			return true;
		},
		favorite: {
			reloadBlocks: {
				'/': [],
				'/products-lists/favorites': ['page']
			},
			updateURL: languagePrefix + '/products/'
		},
		compare: {
			reloadBlocks: {
				'/': [],
				'/products-lists/compare': ['page']
			},
			updateURL: languagePrefix + '/products-lists/compare'
		},
		watchdog: {
			reloadBlocks: {
				'/': [],
				'/products-lists/watchdog': ['page']
			},
			updateURL: languagePrefix + '/products-lists/watchdog'
		},
		basket: {
			reloadBlocks: {
				'/': [],
				'/kosik/': ['page']
			},
			updateURL: languagePrefix + '/kosik/',
			moduleBlock: '$BASKET',
			tabSyncCallback: ()=>{ self.basket.load() },
			defaultBasket: null
		},
		cookie: {
			render: 'bar',
			btnAllowNecessary: true
		},
		statusBox: ''
	};

	this.init = function (options) {
		options = options || {};
		EBContext.utils.extendObj(false, self.options, options);
		self.cookie.initConsent();
		document.addEventListener('EBContext.session.login', e=>self.basket.load());
	};

	/**
	 * Vr�t� bloky k reloadu podle typu seznamu a aktu�ln� str�nky
	 * ��d� se mapou blok� a str�nek v options[type].reloadBlocks
	 */
	var getReloadBlocks = function (types) {
		var i, j;
		if (!(types instanceof Array)) types = [types];
		var pathname = window.location.href.toString().replace(/https?\:\/\/[^\/]+/gi, '').split('?')[0];
		var reloadBlocks = [];
		for (i = 0; i < types.length; i++) {
			var keysArr = Object.keys(self.options[types[i]].reloadBlocks);
			for (j = 0; j < keysArr.length; j++) {
				if (pathname.indexOf(languagePrefix + keysArr[j]) === 0) {
					reloadBlocks = EBContext.utils.array.merge(reloadBlocks, self.options[types[i]].reloadBlocks[keysArr[j]]);
				}
			}
		}
		return reloadBlocks;
	};

	/**
	 * Zpracov�v� p�id�v�n� a odeb�r�n� produkt� v seznamech jako favorites, watchdog a compare
	 * V�dy u v�ech p�edan�ch produkt� prov�d� stejnou akci
	 */
	var setState = function (type, item, state, qsParams, postParams, callback) {
		let reloadBlocks = getReloadBlocks(type).join(',');
		var reloadUrl = EBContext.utils.extendURL('/?ajax=1&ebpageitemupdate=' + (reloadBlocks ? reloadBlocks : '*page'), qsParams);
		if (self.options[type].updateURL) reloadUrl = EBContext.utils.extendURL(self.options[type].updateURL, (reloadUrl + '?').split('?')[1]);

		EBContext.ajaxNav.ajaxCall(reloadUrl, function (response, options) {
			var msg = EBContext.resource('MSG_' + type + (state ? 'Add' : 'Remove') + 'OK');
			var msgType = 'success';
			if (options.responseStatus > 399) { // Pokud to spadne s chybou, tak chybu nastavit, jinak po��t�me s t�m, �e to prob�hlo �sp�n�
				msg = EBContext.resource('MSG_' + type + (state ? 'Add' : 'Remove') + 'ERR');
				msgType = 'error';
			} else {
				/**
				 * Pokud akce prob�hla �sp�n�, tak jej� v�sledek p�epsat do indik�tor� u produkt� na aktu�ln� str�nce, 
				 * a nasynchronizovat na ostatn� z�lo�ky z�pisem do localStorage
				 */
				updateState(type, item, state, true); // provede updateState na t�to z�lo�ce
				if (EBContext.tabSync) EBContext.tabSync.update(type, {
					oid: item,
					state: state
				}); // toto prakticky jen provede updateState na ostatn�ch z�lo�k�ch
			}

			if (typeof callback === 'function') {
				callback(response);
			}

			self.notify(msg, msgType);
		}, postParams);
		return false;
	};

	/** 
	 * Aktualizuje stav produkt� v DOM 
	 * Pokud je na v�pisu produkt� dan�ho typu (m��e doj�t k p�id�n�/odebr�n� produktu v zobrazen�), tak z�rove� provede reload blok� z options.
	 */
	var updateState = function (type, items, state, reload, callback) {
		if (!(items instanceof Array)) items = [items];

		// Aktualizace stavu produktu (fav, comp, bsk, ...) v DOM
		for (var i = 0; i < items.length; i++) {
			self.options.statusUpdate(type, items[i], state);
		}

		// Reload blocks
		if (reload) {
			var reloadBlocks = getReloadBlocks(type).join(',');
			if (reloadBlocks) {
				EBContext.ajaxNav.ajaxCall(
					EBContext.utils.createAjaxURL(
						window.location.href, { // options for createAjaxURL
							reload: reloadBlocks
						}
					),
					callback
				);
				return true;
			}
		} else if (callback && typeof callback === 'function') return callback();
		return true;
	};

	this.events = {
		login: new Event('EBContext.session.login', {
			'bubbles': true,
			'cancellable': false,
			'composed': true
		}),
		logout: new Event('EBContext.session.logout', {
			'bubbles': true,
			'cancellable': false,
			'composed': true
		}),
		refreshTimeout: new Event('EBContext.session.refreshTimeout', {
			'bubbles': true,
			'cancellable': false,
			'composed': true
		}),
		setLanguage: new Event('EBContext.session.setLanguage', {
			'bubbles': true,
			'cancellable': false,
			'composed': true
		}),
		setCurrency: new Event('EBContext.session.setCurrency', {
			'bubbles': true,
			'cancellable': false,
			'composed': true
		}),
		setLocale: new Event('EBContext.session.setLocale', {
			'bubbles': true,
			'cancellable': false,
			'composed': true
		}),
		setConsent: new Event('EBContext.session.setConsent', {
			'bubbles': true,
			'cancellable': false,
			'composed': true
		}),
		confirmConsent: new Event('EBContext.session.confirmConsent', {
			'bubbles': true,
			'cancellable': false,
			'composed': true
		})
	};
	this.redirect = {
		redirects: [],
		add: function(events,to,from){
			if(!Array.isArray(events)) events = [events];
			to = to || '/';
			from = from || '.*';
			
			let redir = self.redirect.redirects.find(red=>(red.from === from && red.to === to));
			if(redir){ 
				redir.events = EBContext.utils.extendObj(true,redir.events, events);
			} else {
				redir = {events: events, from: from, to:to};
				self.redirect.redirects.push(redir);
				self.redirect.redirects.sort((a,b)=>a.from.length-b.from.length);
			}
			return redir;
		},
		find: function(eventName, pathName){
			pathName = pathName || location.pathname;
			let redir = self.redirect.redirects.find(red=>{
				if(!red.events.includes(eventName)) return false;
				let re = new RegExp(red.from);
				return re.test(pathName);
			});
			if(redir) return redir.to;
			return null;
		},
		remove: function(events,to,from){
			return; //@TODO
		}
	};
	this.notify = function (message, icon, element) {
		if (!element) {
			element = document.getElementById('notificationElement');
			if (!element) {
				element = document.createElement('div');
				element.style.cssText = "position:absolute;right:20px;top:10px;";
				element.id = "notificationElement";
				document.body.appendChild(element);
			}
			require(['notifyjs'], () => {
				$(element).notify(message, {
					className: icon,
					position: 'bottom right'
				});
			});
		}
	};
	this.user = {
		id: EBContext.data.session['User.ID'] || null,
		auth: false,
		anonym: false,
		login: function (login, password, redir, autologin) {
			EBContext.async.start('login');
			redir = redir || self.redirect.find('EBContext.session.login') || null;
			EBContext.ajaxNav.call('$LOGIN.login', (response, options) => {
				response = JSON.parse(response);
				if (!response.result) EBContext.session.notify(response.error, 'warn');
				if(response.result) EBContext.modal.clear();
				EBContext.ajaxNav.ready(() => EBContext.async.finish('login'));
			}, EBContext.utils.paramsObjToStr({
				login_username: login,
				login_password: password,
				autologin: autologin,
				responseparams: {redirect: redir}
			}, true), null, {session: 1});
		},
		loginDialog: function (login, redir) {
			if (login) document.forms.loginForm.elements.username.value = login;
			if (redir) document.forms.loginForm.elements.redir.value = redir;
			EBContext.popup('#loginPopup',{disposeOnClose:false});
		},
		logout: function (confirmed, callback, options) {
			options = EBContext.utils.extendObj(false, {logoutURL: EBContext.data.languageUrl || null}, options);
			if (!confirmed) {
				EBContext.confirm(EBContext.resource('EBC_CONFIRM_LOGOUT'), function (resp) {
					if (resp) self.user.logout(resp, callback, options);
				});
			} else {
				EBContext.async.start('logout');
				EBContext.ajaxNav.call('$LOGIN.logout', response => {
					response = JSON.parse(response);
					if (response.result || response.error === 'NOT_AUTHORIZED') {
						self.user.clearSession();
						if (typeof callback === 'function') callback();
					} else {
						EBContext.session.notify(response.error, 'warn');
					}
					EBContext.ajaxNav.ready(() => EBContext.async.finish('logout'));
				}, EBContext.utils.paramsObjToStr({responseparams: {redirect: options.logoutURL}}, true), null, {session: 1});
			}
		},
		clearSession: function () {
			if (typeof Storage !== 'undefined') {
				sessionStorage.clear();
				localStorage.clear();
			}
			document.cookie = 'auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
			self.user.id = null;
			self.user.auth = false;
			self.user.anonym = false;
			self.basket.items = [];
			self.basket.loaded = false;
			if (EBContext.tabSync) EBContext.tabSync.update('userId', '');
		},
		setLanguage: function (code) {
			let url = '/';
			code = code.toLowerCase();
			if(code !== EBContext.data.defaultLanguage) url += code;
			// EBContext.ajaxNav.navigationTrigger(url, null, null, {reload: 'BODY'});
			window.location.href = url;
			document.dispatchEvent(self.events.setLanguage);
		},
		setCurrency: function (code, callback) {
			// var pd = EBContext.ajaxNav.currentState.postData;
			EBContext.ajaxNav.call('$LOGIN.changeCurrency', resp => {
				if(resp){
					let sessionProps = {};
					try {
						sessionProps = JSON.parse(resp);
					} catch (e) {
						console.error('Error parsing session properties after currency change!', e, resp);
					}
					EBContext.utils.extendObj(false, EBContext.data.session, sessionProps);
					EBContext.ajaxNav.setEnv('currency', code);
				}
				document.dispatchEvent(self.events.setCurrency);
				if(callback && 'function' === typeof callback){
					callback();
				} else {
					EBContext.ajaxNav.navigationTrigger(null, null, null /*pd*/, {
						navigation: false,
						reload: 'BODY'
					});
				}
			}, null, null, {
				currency: code
			});
		},
		setLocale: function (lang, cur) {
			self.user.setCurrency(cur, ()=>self.user.setLanguage(lang));
		},
		setPrices: function (mode){
			EBContext.ajaxNav.navigationTrigger(null, null, null, {
				navigation: false,
				reload: 'BODY',
				requestParams: {showPrices: mode}
			});
		}
	};
	this.cookie = {
		reasons: {
			SYSTEM: {
				id: 'SYSTEM',
				order: 0,
				// cookies: [
				// 	{
				// 		id: 'SESSIONID',
				// 		domain: 'luse.mywac.cz',
				// 		valid: EBContext.resourceInflection('dny', 365),
				// 		description: 'Zaji��uje konzistenci dat p�i proch�zen� webu (p�ihl�en� u�ivatel, polo�ky v ko��ku, ulo�en� nastaven�, ...)',
				// 		issuer: 'myWAC Technologies s.r.o.'
				// 	}, {
				// 		id: 'allowCookies',
				// 		domain: '*.mywac.cz',
				// 		valid: EBContext.resourceInflection('dny', 299),
				// 		description: 'Zaji��uje potvrzen�, �e jste ji� potvrdili sv� Cookies preference',
				// 		issuer: 'myWAC Technologies s.r.o.'
				// 	}
				// ]
			},
			// ANALYTIC: {
			// 	id: 'ANALYTIC',
			//	order: 1,
			// 	cookies: [
			// 		{
			// 			id: 'GTMID',
			// 			domain: 'luse.mywac.cz',
			// 			valid: EBContext.resourceInflection('dny', 29),
			// 			description: 'Poskytuje jednozna�nou identifikaci relace pro shroma��ov�n� analytick�ch dat',
			// 			issuer: 'Google Inc.'
			// 		}, {
			// 			id: '_sklik',
			// 			domain: '*.mywac.cz',
			// 			valid: EBContext.resourceInflection('dny', 115),
			// 			description: 'Poskytuje jednozna�nou identifikaci relace pro shroma��ov�n� analytick�ch dat',
			// 			issuer: 'Seznam.cz'
			// 		}
			// 	]
			// }
		},
		enable: function (types, expires) {
			if (!expires) {
				expires = new Date();
				expires.setFullYear(expires.getFullYear() + 1);
			}
			return self.cookie.set('allowCookies', types, expires, 'SYSTEM'), document.dispatchEvent(self.events.setConsent);
		},
		set: function (name, value, expires, type) {
			type = type || 'UNDEFINED';
			var exdate = '';
			if (type === 'SYSTEM' || (',' + self.cookie.get('allowCookies') + ',').indexOf(',' + type + ',') > -1) {
				if (expires) {
					exdate = new Date(expires).toUTCString();
					exdate = (exdate ? '; expires=' + exdate : '');
				}
				document.cookie = name + '=' + encodeURIComponent(value) + '; path=/' + exdate;
				return true;
			}
			console.error('%cStoring cookies of type "' + type + '" has not yet been allowed!', EBContext.options.consoleStyles.errorMsg);
			return false;
		},
		get: function (name) {
			var arr = document.cookie.split(';');

			for (var i = 0; i < arr.length; i++) {
				if (name == arr[i].substr(0, arr[i].indexOf('=')).replace(/^\s+|\s+$/g, '')) {
					return decodeURIComponent(arr[i].substr(arr[i].indexOf('=') + 1));
				}
			}
			return null;
		},
		check: function (cookieType) {
			if(!cookieType) cookieType='SYSTEM';
			let allowedReasons = self.cookie.get('allowCookies');
			if (allowedReasons === null) { //pokud nen� ulo�en 
				self.cookie.prompt();
				return false;
			}
			if ((allowedReasons === '*' && Object.keys(self.cookie.reasons).indexOf(cookieType) > -1) || (',' + allowedReasons + ',').indexOf(',' + cookieType + ',') > -1) {
				return true;
			} else {
				return false;
			}
		},
		invalidate: function (name) {
			self.cookie.set(name, '', 'Thu, 01 Jan 1970 00:00:00 GMT', true);
		},
		showSettings: function () {
			let cspEl = document.getElementById('cookiesPopup');
			if (cspEl) cspEl.parentElement.removeChild(cspEl);
			
			let cookiesPrompt = Object.values(EBContext.instances.modalWindow).find(w=>w.id==='cookiesPrompt') || Object.values(EBContext.instances.modalBar).find(b=>b.id==='cookiesPrompt');
			if(cookiesPrompt) cookiesPrompt.close(true);
			
			let allowedReasons = self.cookie.get('allowCookies');
			if (allowedReasons) {
				allowedReasons = allowedReasons.split(',');
				let availableReasons = Object.keys(self.cookie.reasons);
				for (let i = 0; i < availableReasons.length; i++) {
					let reason = self.cookie.reasons[availableReasons[i]];
					reason.enabled = (allowedReasons.indexOf(reason.id) > -1 || allowedReasons[0] === '*');
					self.cookie.reasons[availableReasons[i]] = reason;
				}
			}
			let popupEl = EBContext.utils.template(`<div class="modal fade" id="cookiesPopup" tabindex="-1" role="dialog">
					<form action="javascript:;" method="post" class="modal-dialog modal-lg" role="document" onsubmit="return EBContext.session.cookie.updateSettings(this);">
						<div class="modal-content">
							<div class="modal-header">
								<h3 class="mb-0"><!--~resource.NASTAVENI_COOKIES--></h3>
								<div class="btn" onclick="EBContext.modal.get('#cookiesPopup').close()"><i class="fas fa-fw fa-times"></i></div>
							</div>
							<div class="modal-body">
								<div class="row align-items-center">
									<div class="col-auto"><i class="fas fa-fw fa-4x fa-cookie-bite text-black-50"></i></div>
									<div class="col"><!--~resource.MSG_COOKIES_INFO--></div>
								</div>
								<div class="accordion mt-2" id="cookiesPopup_reasons">
									<!--#reason;~reasons-->
								</div>
							</div>
							<div class="modal-footer">
								<button type="submit" name="preset" value="SYSTEM" onclick="[...this.form.elements.reason].forEach(el=>{if(!el.disabled) el.checked = false}); return true;" class="btn btn-info"><i class="fas fa-fw fa-check me-2"></i><!--~resource.POVOLIT_NEZBYTNE--></button>
								<button type="submit" name="preset" value="*" onclick="[...this.form.elements.reason].forEach(el=>{if(!el.disabled) el.checked = true}); return true;" class="btn btn-info"><i class="fas fa-fw fa-check-double me-2"></i><!--~resource.POVOLIT_VSE--></button>
								<button type="submit" name="preset" value="" class="btn btn-success"><i class="fas fa-fw fa-save me-2"></i><!--~resource.ULOZIT_VOLBY--></button>
							</div>
						</div>
					</form>
				</div>`, {
				reason: `<div class="accordion-item mt-2 border-top">
							    <h2 class="accordion-header" id="cookiesReasonHeading_<!--$id-->">
							      <div class="d-flex align-items-center border-bottom">
							      <div class="form-check form-switch ms-2 pb-1">
							    	  <!--@presetSystem-->
									  <input class="form-check-input" name="reason" value="<!--$id-->" type="checkbox"<!--@reasonPresets--> id="cookiesReasonToggle_<!--$id-->">
									  <label class="form-check-label" for="cookiesReasonToggle_<!--$id-->"></label>
								  </div>
							      <button type="button" class="accordion-button shadow-none collapsed fw-bold" data-bs-toggle="collapse" data-bs-target="#cookiesReasonPanel_<!--$id-->" aria-expanded="true" aria-controls="cookiesReasonPanel_<!--$id-->">
								      <!--@reasonName-->
							      </button>
							    </h2>
							    <div id="cookiesReasonPanel_<!--$id-->" class="accordion-collapse collapse" aria-labelledby="cookiesReasonHeading_<!--$id-->">
							      <div class="accordion-body">
							        <!--@reasonDescription-->
							        <!--$cookies?#cookies-->
							      </div>
							    </div>
							  </div>`,
				cookies: `<div class="row fw-bold d-none d-md-flex border-top mt-2 pt-2">
					        	<div class="col-md-2 px-2 py-md-2"><!--~resource.COOKIE--></div>
					        	<div class="col-md-2 px-2 py-md-2"><!--~resource.DOMENA--></div>
					        	<div class="col-md-2 px-2 py-md-2"><!--~resource.PLATNOST--></div>
					        	<div class="col-md-4 px-2 py-md-2"><!--~resource.POPIS--></div>
					        	<div class="col-md-2 px-2 py-md-2"><!--~resource.ZPRACOVATEL--></div>
					        </div>
					        <!--#cookie;$cookies-->`,
				cookie: `<div class="row border-top mt-2 pt-2">
					        	<div class="col px-2 d-md-none fw-bold"><!--~resource.COOKIE--></div>
					        	<div class="col-md-2 px-2 py-md-2"><!--$id--></div>
					        	<div class="col px-2 d-md-none fw-bold"><!--~resource.DOMENA--></div>
					        	<div class="col-md-2 px-2 py-md-2"><!--$domain--></div>
					        	<div class="col px-2 d-md-none fw-bold"><!--~resource.PLATNOST--></div>
					        	<div class="col-md-2 px-2 py-md-2"><!--$valid--></div>
					        	<div class="col px-2 d-md-none fw-bold"><!--~resource.POPIS--></div>
					        	<div class="col-md-4 px-2 py-md-2"><!--$description--></div>
					        	<div class="col px-2 d-md-none fw-bold"><!--~resource.ZPRACOVATEL--></div>
					        	<div class="col-md-2 px-2 py-md-2"><!--$issuer--></div>
					        </div>`
			}, {
				reasons: Object.values(self.cookie.reasons).sort((a,b)=>(a.order > b.order ? 1 : (a.order < b.order ? -1 : 0))),
				reasonName: obj => EBContext.resource('COOKIES_' + obj.id + '_NAME'),
				reasonDescription: obj => EBContext.resource('COOKIES_' + obj.id + '_DESC'),
				reasonPresets: obj => {
					if (obj.id === 'SYSTEM') return ' checked disabled';
					if (obj.enabled) return ' checked';
					return '';
				},
				presetSystem: obj => (obj.id === 'SYSTEM' ? '<input type="hidden" name="reason" value="SYSTEM">' : '')
			})[0];
			document.body.appendChild(popupEl);
			EBContext.popup('#cookiesPopup',{disposeOnClose:true, onHideCallback: ()=>EBContext.session.cookie.check('SYSTEM')});
		},
		updateSettings: function (form) {
			let formData = EBContext.utils.serializeForm(form, true);
			let reasonsStr = formData.preset || formData.reason;
			if (!reasonsStr) return false;
			let cookiesPopup = EBContext.modal.get('#cookiesPopup');
			return self.cookie.enable(reasonsStr) && setTimeout(() => {
				if (cookiesPopup) cookiesPopup.close();
				/*
					Toto jednor�zov� vypne ajaxNav - po reloadu se zase zapne - tedy neprob�hne reload okam�it�, ale p�i dal��m odesl�n� �ehokoliv
					Ne v�echno se ale um� spr�vn� odeslat bez ajaxNav! - @TODO - vymyslet reload hlavi�ky pro na�ten� za�len�n� bez reloadu cel� str�nky
				*/
				EBContext.ajaxNav.navigationEnabled = false; //window.location.reload();
				document.dispatchEvent(self.events.confirmConsent);
			}, 500);
		},
		clear: function () {
			var cookies = document.cookie.split(';');
			var i;
			for (i = 0; i < cookies.length; i++) {
				var eqPos = cookies[i].indexOf('=');
				self.cookie.invalidate(eqPos > -1 ? cookies[i].substr(0, eqPos) : cookies[i]);
			}
			return true;
		},
		prompt: function (options) {
			if (myWAC && myWAC.interface) return self.cookie.enable('*');
			
			options = EBContext.utils.extendObj(false, {
				render: 'popup', // bar, overlay, notification
				position: ['center', 'center'], // [left|right, top|bottom]
				btnAllowNecessary: true,
			}, self.options.cookie, options);
			
			// close and dispose of existing instance before creatinga new one (for example with different options)
			let cookiesPrompt = Object.values(EBContext.instances.modalWindow).find(w=>w.id==='cookiesPrompt') || Object.values(EBContext.instances.modalBar).find(b=>b.id==='cookiesPrompt');
			if(cookiesPrompt && !options) return;
			if(cookiesPrompt) cookiesPrompt.close(true);
			let modal_callback = (resp, modal) => {
				let i;
				if (resp===1) {
					// for(i=0;i<self.cookie.requests.length;i++){
					// 	self.cookie.requests[i].callback(resp);
					// }
					return self.cookie.enable('*') && setTimeout(() => {
						if(modal) modal.close(true);
						EBContext.ajaxNav.navigationEnabled = false;
						document.dispatchEvent(self.events.confirmConsent);
					}, 500);
				} else if(resp===2){
					if(modal) modal.close(true);
					EBContext.session.cookie.showSettings();
				} else {
					return self.cookie.enable('SYSTEM') && setTimeout(() => {
						if(modal) modal.close(true);
						EBContext.ajaxNav.navigationEnabled = false;
						document.dispatchEvent(self.events.confirmConsent);
					}, 500);
				}
			};
			let reasonsString = '';
			let reasonsArr = [];
			let i;
			for (i = 0; i < self.cookie.requests.length; i++) reasonsArr = EBContext.utils.array.merge(reasonsArr, self.cookie.requests[i].reasons);
			for (i = 0; i < reasonsArr.length; i++) reasonsString += (i === 0 ? '' : ', ') + EBContext.resource('COOKIE_REASON_' + reasonsArr[i]);

			switch (options.render) {
				case 'bar':
					return new EBContext.modules.ModalBar(EBContext.resource('MSG_COOKIES_CONFIRM_REASONS') + reasonsString, modal_callback, {
						heading: null,
						fullwidth: false,
						btnOK: {
							show: true,
							text: '<span class="d-md-block"><i class="fas fa-fw va-2x fa-check-double"></i></span><span class="ms-2 d-md-inline">' + EBContext.resource('POVOLIT_VSE') + '</span>',
							title: EBContext.resource('POVOLIT_VSE'),
							class: 'btn btn-primary',
							order: 1,
							value: 1
						},
						btnCancel: {
							show: options.btnAllowNecessary,
							text: '<span class="d-md-block"><i class="fas fa-fw va-2x fa-check"></i></span><span class="ms-2 d-md-block">' + EBContext.resource('POVOLIT_NEZBYTNE') + '</span>',
							title: EBContext.resource('POVOLIT_NEZBYTNE'),
							class: 'btn btn-primary',
							order: 3,
							value: 0
						},
						moreButtons: [{
							show: true,
							text: '<span class="d-md-block"><i class="fas fa-fw va-2x fa-cog"></i></span><span class="ms-2 d-md-block">' + EBContext.resource('PREDVOLBY') + '</span>',
							title: EBContext.resource('PREDVOLBY'),
							class: 'btn btn-primary',
							order: 2,
							value: 2, 
							idPrefix: 'btnOptions'
						}],
						closeOnSubmit: true,
						modalId: 'cookiesPrompt',
						failedToShowCallback: function(modalEl){
							if(false && !EBContext.utils.element.isVisible(modalEl)){
								alert('V� prohl�e� aktivn� blokuje zobrazen� formul��e pro nastaven� souhlasu s pou�it�m Cookies. Pros�m vypn�te si toto blokov�n�, nebo p�idejte tento web do v�jimek a n�sledn� obnovte str�nku.');
							}
						}
					});
				default: // popup
					EBContext.confirm(EBContext.resource('MSG_COOKIES_CONFIRM_REASONS') + '\n\n' + reasonsString, modal_callback, {
						heading: EBContext.resource('HEADING_COOKIES_CONFIRM'),
						modal: true,
						fade: false,
						centered: (options.position[1] === 'center'),
						btnOK: {
							text: '<span><i class="fas fa-fw va-2x fa-check-double"></i></span><span class="ms-2">' + EBContext.resource('POVOLIT_VSE') + '</span>',
							title: EBContext.resource('POVOLIT_VSE'),
							class: 'btn btn-primary',
							order: 1,
							value: 1
						},
						btnCancel: {
							show: options.btnAllowNecessary,
							text: '<span><i class="fas fa-fw va-2x fa-check"></i></span><span class="ms-2">' + EBContext.resource('POVOLIT_NEZBYTNE') + '</span>',
							title: EBContext.resource('POVOLIT_NEZBYTNE'),
							class: 'btn btn-primary',
							order: 3,
							value: 0
						},
						moreButtons: [{
							text: '<span><i class="fas fa-fw va-2x fa-cog"></i></span><span class="ms-2">' + EBContext.resource('PREDVOLBY') + '</span>',
							title: EBContext.resource('PREDVOLBY'),
							class: 'btn btn-primary',
							order: 2,
							value: 2, 
							idPrefix: 'btnOptions'
						}],
						enableEscapeKey: false,
						modalId: 'cookiesPrompt',
						// failedToShowCallback: function(modalEl){
						// 	if(false && !EBContext.utils.element.isVisible(modalEl)){ //p�ed�v� se jin� modalEl ne� se zobrazuje, tak�e alert vyskakuje v�dy - TODO
						// 		alert('V� prohl�e� aktivn� blokuje zobrazen� formul��e pro nastaven� souhlasu s pou�it�m Cookies. Pros�m vypn�te si toto blokov�n�, nebo p�idejte tento web do v�jimek a n�sledn� obnovte str�nku.');
						// 	}
						// }
					});
			}
			/** @TODO
			 * - p�i zavol�n� zobrazit mod�ln� popup pro potvrzen�/v�b�r povolen�ch cookies
			 * - aby nevyskakovalo v�ce oken po sob�, tak by se requesty o ukl�d�n� cookies m�ly pomoc� 'EBContext.session.cookie.register' pushovat do pole, a prompt by pak m�l umo�nit v jednom okn� nastavit povolen� jednotliv�ch cookies
			 **/
		},
		initConsent: function(){
			document.dispatchEvent(self.events.setConsent);
		},
		/**
		 * - m�lo by se volat p�ed inicializac� libovoln�ho pluginu ukl�daj�c�ho cookies (nap�. Google Analytics, Facebook reklamy, atp...)
		 *	params = {
				id: [string], jednozna�n� id requestu - nap�. n�zev pluginu + API id
				name: [string], n�zev pluginu vy�aduj�c� ukl�d�n� cookies
				description: [string], popis pluginu vy�aduj�c�ho ukl�d�n� cookies
				reasons: [Array], v��et d�vod� ukl�d�n� cookies - [advertising, analystics, ...],
				callback: [function(allowed)] zavol� se s v�sledkem requestu pro dan� plugin
			}; 
		**/
		register: function (params) {
			if (!self.cookie.requests.find(a => a.id === params.id))
				self.cookie.requests.push(params);
		},
		requests: [],
	};
	this.validateAge = function(requiredAge) {
		let consentStr = self.cookie.get('ageValidation');
		let age = 0;
		if (consentStr) age=parseInt(consentStr);
		if (age<requiredAge) {
			EBContext.confirm(EBContext.resource('MSG_POZADOVAN_VEK').replace(/#AGE#/g, requiredAge), resp=>{
				if(resp) return self.cookie.set('ageValidation', requiredAge, null, 'SYSTEM');
				history.back();
			}, {
				fade: false,
				heading: EBContext.resource('OVERENI_VEKU'),
				btnOK: {
					text: EBContext.resource('AGE_CONFIRM').replace(/#AGE#/g, requiredAge),
					title: EBContext.resource('AGE_CONFIRM').replace(/#AGE#/g, requiredAge)
				},
				btnCancel: {
					show: true,
					text: EBContext.resource('AGE_DENY').replace(/#AGE#/g, requiredAge),
					title: EBContext.resource('AGE_DENY').replace(/#AGE#/g, requiredAge)
				}
			});
		}
	};
	this.keepAlive = {
		refreshCount: 0,
		refreshTimeout: null,
		init: function (options) {
			EBContext.utils.extendObj(true, self.options.keepAlive, options);
			self.keepAlive.refreshCount = self.options.keepAlive.refreshCount;
			self.keepAlive.refreshTimeout = setTimeout(function () {
				self.keepAlive.refresh();
			}, self.options.keepAlive.refreshTimeout);
			document.addEventListener('EBContext.ajaxNav.navigate', function () {
				self.keepAlive.reset();
			});
		},
		refresh: function () {
			self.keepAlive.refreshCount--;
			if (self.keepAlive.refreshCount > 0) {
				var rnd = new Date().getTime() + Math.random();
				EBContext.utils.xmlHttp({
					url: self.options.keepAlive.rootPath + 'refresh?rnd=' + rnd
				});

				self.keepAlive.refreshTimeout = setTimeout(function () {
					self.keepAlive.refresh();
				}, self.options.keepAlive.refreshTimeout);
			} else {
				document.dispatchEvent(self.events.refreshTimeout);
			}
		},
		reset: function () {
			self.keepAlive.refreshCount = self.options.keepAlive.refreshCount;
			clearTimeout(self.keepAlive.refreshTimeout);
			self.keepAlive.refreshTimeout = setTimeout(function () {
				self.keepAlive.refresh();
			}, self.options.keepAlive.refreshTimeout);
		}
	};
	this.basket = {
		items: [],
		loaded: false,
		summary: {},
		renderers: [],
		callbacks: {
			upsalePopup: (response, options)=>{
				if(options.action==='addGood' && EBContext.data.hrefMap.popup_upsale){
					let items = response.items.filter(item=>item.ok).map(item=>item.oid) || [];
					let popupURL = EBContext.data.hrefMap.popup_upsale + '?Good=' + items.join(',');
					EBContext.popup(popupURL);
				}
			}
		},
		// goods = [{oid: oid1, amount: amount1, ...}, {oid: oid2, amount: amount2, ...}, ... ];
		add: function (goods, basket, callback, options) {
			if(!Array.isArray(goods)) goods = [goods];
			self.basket.update(goods, callback, EBContext.utils.mergeObj(false, options, {action:'addGood', basket: basket}));
		},
		// basketItems = {oid1: {amount: amount1, comment: comment1, ...}, {oid: oid2, amount: amount2, ...}, ... };
		update: function (basketItems, callback, options) {
			EBContext.async.start('basketUpdate');
			options = EBContext.utils.extendObj(false, {action: 'updateItems'}, options);
			console.debug(options.callback);
			
			let basketItemsArr = [];
			if(Array.isArray(basketItems)){ // Update s daty ve form�tu pro Add by se m�l volat jen jako callback resolve, tak u� by m�l m�t v�e ve spr�vn�m form�tu 
				basketItemsArr = basketItems;
			} else { // p�vodn� form�t dat pro Update je pot�eba zkonvertovat do form�tu pro Add
				basketItemsArr = Object.entries(basketItems).map(ent=>EBContext.utils.extendObj(false,ent[1],{basketpol: ent[0], direct: true, oid: EBContext.session.basket.items.find(bi=>bi.OID===ent[0]).Good}));
			}
			EBContext.ajaxNav.call(self.options.basket.moduleBlock + '.AddItems', (response, options) => {
				self.basket.processResponse(response, {action: options.action, callback: callback});
			}, 'goods=' + encodeURIComponent(JSON.stringify(basketItemsArr)), self.options.basket.updateURL, null, options);
		},
		topAmount: function(basketItems, options){
			if(!Array.isArray(basketItems)) basketItems = [basketItems];
			if(!basketItems.length) return;
			let topObj = {};
			require(['EBContext_Loader'], () => {
				for (let i = 0; i < basketItems.length; i++) {
					topObj[basketItems[i]] = {topAmount: true};
				}
				let loader = new EBContext.modules.Loader({
					parentElement: [...document.querySelectorAll('.basket-product')].filter(el => basketItems.includes(el.getAttribute('data-oid'))),
					loaderType: 'replace'
				});
				self.basket.update(topObj, null, options);
			});
		},
		// basketItems = [oid1, oid2, oid3, ...];
		remove: function (basketItems, options) {
			options = EBContext.utils.extendObj(false, {action:'removeItems'}, options);
			if(!Array.isArray(basketItems)) basketItems = [basketItems];
			if(!basketItems.length) return;
			
			let rmObj = {};
			require(['EBContext_Loader'], () => {
				for (let i = 0; i < basketItems.length; i++) {
					rmObj[basketItems[i]] = {
						remove: true,
						basketpol: basketItems[i]
					};
				}
				let loader = new EBContext.modules.Loader({
					parentElement: [...document.querySelectorAll('.basket-product')].filter(el => basketItems.includes(el.getAttribute('data-oid'))),
					loaderType: 'replace'
				});
				self.basket.update(rmObj, null, options);
			});
		},
		removeGood: function(goodOID){
			let mj = '';
			let total = 0;
			var rmBasketItems = self.basket.items.filter(bi=>(bi.Good === goodOID && !bi.RelatedItem));
			rmBasketItems.forEach(bi=>{
				if(!mj) mj = bi.MJ;
				total += bi.Amount;
			});
			rmBasketItems = rmBasketItems.map(bi=>bi.OID);
			return EBContext.confirm(EBContext.resource('MSG_ODEBRAT_POLOZKY_Z_KOSIKU').replace('#POCET#', total + (mj ? ' ' + mj : '')), resp => {
				if(resp) self.basket.remove(rmBasketItems, {action: 'removeGood'});
				return false;
			}, {
				heading: EBContext.resource('ODEBRAT_Z_KOSIKU'),
				btnOK: {
					text: EBContext.resource('ODEBRAT_POLOZKY')
				},
				btnCancel: {
					text: EBContext.resource('ZRUSIT'),
					class: 'btn btn-block d-md-inline w-md-auto float-left btn-success mt-2 text-truncate'
				},
				btnEsc: {
					show: true
				},
				modal: false
			});
		},
		removeAll: function () {
			let oids = [];

			self.basket.items.forEach(item =>{if(!item.RelatedItem) oids.push(item.OID); return true});
			self.basket.remove(oids, {action: 'emptyBasket'});
		},
		load: function (callback, options) {
			options = EBContext.utils.extendObj(false, {
				navigation: false,
				loader: {
					enabled: false,
					ajaxQueue: []
				}
			}, options);
			EBContext.ajaxNav.call(self.options.basket.moduleBlock + '.getItems', (response, options) => {
				self.basket.processResponse(response, {action:'loadBasket', callback: callback});
			}, null, self.options.basket.updateURL, null, options);
		},
		form: function (formEl, options) {
			options = EBContext.utils.extendObj({
				refObj: '',
				notificator: EBContext.notify,
				callback: null,
				loaderBox: null //@TODO - doplnit loader na tla��tko "do ko��ku" u polo�ky aby glob�ln� loader neblokoval celou str�nku - pou��t jen u push notifikac� o p�id�n� do ko��ku - ne p�i potvrzen� popupem!
			}, options);
			let getProductsEls = formEl=>{
				let productsEls = [...formEl.querySelectorAll('.product')];
				if (productsEls.length <= 1) productsEls = [formEl];
				if(formEl.nodeName !== 'FORM') productsEls = productsEls.filter(el=>!!el.querySelector('[name=selected]:checked'));
				return productsEls;
			};
			var resetValues = formEl=>{
				let productsEls = getProductsEls(formEl);
				productsEls.forEach(pEl=>{
					let inputAmount = pEl.querySelector('[name=amount]'),
						inputPackage = pEl.querySelector('[name=package]'),
						selectedEl = pEl.querySelector('[name=selected]');
					if(selectedEl) selectedEl.checked = false;
					let min = inputAmount.getAttribute('min');
					min = (typeof min === 'undefined' ? 1 : parseFloat(min));
					inputAmount.value = min;
					if(!selectedEl && inputPackage) self.basket.updateAmount(inputPackage);
				});
			};
			
			// v ��dkov�m v�pisu produkt� - pokud je zapnut� batchMode/multiSelect, tak je pot�eba odeslat v�echny produkty			
			if(formEl.querySelector('[name=selected]')) formEl = formEl.closest('.batch_container') || formEl.closest('form');
			let productsEls = getProductsEls(formEl);
			
			let basketData = [];
			// let askSeparate = [];
			let separateCount = 0;
			let i;
			for (i = 0; i < productsEls.length; i++) {
				let formEl = productsEls[i];

				let selectedEl = formEl.querySelector('[name=selected]');
				if (selectedEl && !selectedEl.checked) continue;

				// Declaration of variables
				let oid, am, ref, sep, com, pkg, quot, dir, eid, name, unit, step, min, max, separate, btnBasketAdd, inputAmount, inputPackage, inputComment, inputQuotation, inputDirect, inputEid, inputName, inputUnit, inputRef, inputSeparate, goodext;

				// DOM elements
				btnBasketAdd = formEl.querySelector('[type=submit]');
				inputAmount = formEl.querySelector('[name=amount]');
				inputPackage = formEl.querySelector('[name=package]');
				inputComment = formEl.querySelector('[name=comment]');
				inputGoodExt = formEl.querySelector('[name=goodext]');
				inputQuotation = formEl.querySelector('[name=quotation]');
				inputDirect = formEl.querySelector('[name=direct]');
				inputEid = formEl.querySelector('[name=eid]');
				inputName = formEl.querySelector('[name=name]');
				inputUnit = formEl.querySelector('[name=unit]');
				inputRef = formEl.querySelector('[name=reference]');
				inputSeparate = formEl.querySelector('[name=separate]');

				// Converting values with fallback
				oid = inputAmount.getAttribute('data-oid') || formEl.getAttribute('data-oid') || inputAmount.closest(self.options.productWrapSelector).getAttribute('data-oid');

				step = parseFloat(inputAmount.getAttribute('step')) || null;
				max = parseFloat(inputAmount.getAttribute('max')) || null;
				min = parseFloat(inputAmount.getAttribute('min')) || step || 0;
				am = parseFloat(inputAmount.value) || min;

				name = (inputName ? inputName.value : inputAmount.getAttribute('data-good-name')) || undefined;

				if (inputPackage) pkg = parseFloat(inputPackage.value) || 1;
				if (inputComment) com = inputComment.value;
				if (inputGoodExt) goodext = inputGoodExt.value;
				if (inputQuotation) quot = (inputQuotation.value ? 1 : 0);
				if (inputDirect) dir = (inputDirect.value ? 1 : 0);
				if (inputEid) eid = inputEid.value;
				if (inputUnit) unit = inputUnit.value;
				if (inputRef) ref = inputRef.value;
				if (inputSeparate) sep = (inputSeparate.value === '1');
				sep = options.separate || sep || false;

				if (self.basket.checkAmount(inputAmount)) {
					if (self.basket.items.find(item => item.Good === oid && item.GoodExt === goodext) && !inputSeparate) {
						separateCount++;
					}
					let basketItemData = {
						oid: oid,
						amount: am,
						name: name,
						reference: ref,
						comment: com,
						goodext: goodext,
						package: pkg,
						eid: eid,
						quotation: quot,
						unit: unit
					};
					if(sep) basketItemData.basketpol='*';
					basketData.push(basketItemData);

					// goods = [{ oid: oid1, amount: amount1, basketpol: basketpol1, reference: reference1, comment: comment1, package: package1, quotation: quotation1, direct: direct1, eid: eid1, name: name1, unit: unit1 }, { ... }, ... ]
				}
			}

			if (basketData.length > 0) {
				if(basketData.length === 1 && separateCount === 1 && !('separate' in options)) {
					return EBContext.confirm(EBContext.resource('MSG_POLOZKA_JE_JIZ_V_KOSIKU'), resp => {
						basketData.forEach(bi => {
							bi.basketpol = (resp ? '' : '*');
						});
						self.basket.add(basketData, null, options.callback);
						setTimeout(()=>resetValues(formEl), 1000);
					}, {
						heading: EBContext.resource('POLOZKA_JE_JIZ_V_KOSIKU'),
						btnOK: {
							text: EBContext.resource('NAVYSIT_MNOZSTVI')
						},
						btnCancel: {
							text: EBContext.resource('PRIDAT_DALSI_POLOZKU'),
							class: 'btn btn-block d-md-inline w-md-auto float-left btn-success mt-2 text-truncate'
						},
						btnEsc: {
							show: true
						},
						modal: false
					});
				} else {
					setTimeout(()=>resetValues(formEl), 1000);
					self.basket.add(basketData, null, options.callback, options);
				}
			} else {
				self.notify(EBContext.resource('MSG_NEVYBRANA_ZADNA_POLOZKA'), 'warning');
			}
		},
		upload: function(formEl, options){
			let processedForm = EBContext.utils.form.process(formEl, options);
			if(!processedForm) return false;
			options = options || {};
			options.ignoreRedirects = true;
			EBContext.ajaxNav.ajaxCall('../upload/upload_ajax.asp?upload_callback=$BASKET.importBasket', (response, options)=>{
				// console.log('basket import response: ', response);
				let callback = ()=>{
					return EBContext.ajaxNav.navigationTrigger(self.options.basket.updateURL);
				}
				return self.basket.processResponse(response, {action:'importBasket', callback: callback});
			}, processedForm.postData, options);
		},
		resolve: function(items, options){
			let cb, zpusobyPripravy;
			if('function' === typeof options.callback) cb = options.callback;
			if(!items.find(a=>!a.ok)){
				// console.debug('DEBUG - �e�en� konflikt� ko��ku - ��dn� polo�ky k do�e�en�', items);
				if(cb) cb(items, options);
				return true; //EBContext.ajaxNav.navigationTrigger(self.options.basket.updateURL);
			}
			zpusobyPripravy = options.zpusobyPripravy || {};
			items.forEach(item=>{
				do{
					item._id = 'item_' + Math.floor(Math.random()*10000);
				} while(items.find(item2=>(item2 !== item && item2._id === item._id)));
			});
			let resolvePopup = EBContext.utils.template('<div class="modal" id="basketResolve" tabindex="-1" role="dialog"><div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document"><div class="modal-content" id="basketResolveContent"><!--#modalHeader--><!--#modalBody--><!--#modalFooter--></div></div></div>', {
				modalHeader: '<div class="modal-header"><h5 class="modal-title"><!--~resource.KONFLIKTY_KOSIKU--></div></h5>',
				modalBody: '<div class="modal-body p-1"><form action="#" <!--!submit@fnProcessForm--> id="formFixBasketAdd" method="POST"><!--#basketItem;$:items--><button type="submit" id="submitFixBasketAdd" class="d-none"></button></form></div>',
				basketItem: '<div class="border m-2 p-2"><!--@fnRenderItem--></div>',
				modalFooter: '<div class="modal-footer"><label for="submitFixBasketAdd" class="btn btn-primary"><!--~resource.POTVRDIT--></label><button class="btn btn-danger ms-2"<!--!click@fnClose-->><!--~resource.ZAVRIT--></buton></div>'
			}, {
				items: items,
				callback: cb,
				fnRenderItem: a=>{
					let i, j;					
					let itemTemplate = '<h5><!--$name--></h5>';
					let alertClassMap = {ERR: 'danger', WARN: 'warning', OK: 'success'};
					let iconMap = {ERR: 'times-circle', WARN: 'exclamation-triangle', OK: 'check-square'};
					if(a.message){
						for(i=0;i<a.message.length;i++){
							let m = a.message[i];
							let fot = 'radio';
							let fos = [];
							if(a.oid){
								let bi = EBContext.session.basket.items.find(i=>i.OID===a.oid);
								if(bi){
									if(!a.name) a.name = bi['Name'];
									if(!a.unit) a.unit = bi['MJ'];
								}
							}
							if(!a.name) a.name = a.name_alt;
							if(!a.name && a.search) a.name = Object.values(a.search).join(', ');
							if(!a.name) console.debug('Produkt nenalezen: ', a);
							if(!a.unit) console.debug('Jednotka nenalezena: ', a);
							switch (m.message) {
								case 'MSG_ITEM_EXISTS_SEPARATE':
									//'Tento produkt ji� v ko��ku m�te. P�ejete si nav��it mno�stv� prvn� stejn� polo�ky, nebo p�idat polo�ku novou?';
									fot = 'select'; // @TODO - renderovat jako HTML select!
									fos.push({
										title: EBContext.resource('PRIDAT_DALSI_POLOZKU'),
										overrides: {basketpol: '*'},
										selected: true
									});
									fos.push({
										title: EBContext.resource('NEPRIDAVAT'),
										overrides: {ignore: true},
										selected: false
									});
									a.basket_items.map(bi=>self.basket.items.find(bi2=>bi2.OID===bi)).forEach(bi=>{
										fos.push({
											title: bi.Name + ' (' + bi.Amount + (bi.MJ ? ' '+bi.MJ : '') + ')' + (bi.Comment ? ' - ' + bi.Comment : ''),
											overrides: {basketpol: bi.OID}
										});
									});
									break;
								case 'MSG_NEPLATNE_MNOZSTVI':
								case 'MSG_NEPLATNE_MNOZSTVI_MIN':
									//'Zadan� mno�stv� nen� platn�. P�ejete si p�idat produkt v minim�ln�m jednotkov�m mno�stv�?';
									let minJm = a.jm || 1;
									fos = [{
										title: EBContext.resource('NEPRIDAVAT'), //'Nep�id�vat',
										overrides: {ignore: true}
									}, {
										title: EBContext.resource('MIN_JEDN_MN') + '<br>(' + minJm + ' ' + a.unit + ')', //'Minim�ln� jednotkov� mno�stv�',
										overrides: {package: 1, amount: minJm},
										selected: true
									}];
									break;
								case 'MSG_NEPLATNY_TYP_BALENI':
									a.packages.forEach(p=>{
										fos.push({
											title: (p.name === a.unit ? p.amount + ' ' + a.unit : a.amount + ' ' + p.name + ' (' + p.amount + ' ' + a.unit + ')'),
											overrides: {package: p.amount},
											selected: !fos.length //true jen u prvn� polo�ky
										});
									});
									break;
								case 'MSG_INVALID_AMOUNT_ROUND':
									fos.push({
										title: EBContext.resource(a.oid ? 'NEAKTUALIZOVAT' : 'NEPRIDAVAT'), 
										overrides: {ignore: true}
									});
									let pkgAmount = a.package || 1;
									pkgAmount = pkgAmount * a.amount;
									if(pkgAmount > a.jm){
										let rDown = Math.floor(pkgAmount/a.jm)*a.jm;
										if(!a.hasOwnProperty('max_amount') || rDown <= a.max_amount){
											fos.push({
												title: EBContext.resource('ZAOKROUHLIT_DOLU') + '<br>(' + rDown + ' ' + a.unit + ')', 
												overrides: {package: 1, amount: rDown}
											});
										}
									}
									let rUp = Math.ceil(pkgAmount/a.jm)*a.jm;
									if(!a.hasOwnProperty('max_amount') || rUp <= a.max_amount){
										fos.push({
											title: EBContext.resource('ZAOKROUHLIT_NAHORU') + '<br>(' + rUp + ' ' + a.unit + ')', 
											overrides: {package: 1, amount: rUp},
										});
									}
									fos[fos.length-1].selected = true;
									break;
								case 'MSG_INVALID_AMOUNT_DOCUMENT_MAX':
									fos = [{
										title: EBContext.resource('NEPRIDAVAT'),
										overrides: {ignore: true}
									}, {
										title: EBContext.resource('NASTAVIT_MAX_MN') + '<br>(' + a.max_amount + ' ' + a.unit + ')',
										overrides: {package: 1, amount: a.max_amount, direct: true},
										selected: true
									}];
									break;
								case 'MSG_INVALID_AMOUNT_ITEM_MAX':
									fos = [{
										title: EBContext.resource('NEPRIDAVAT'),
										overrides: {ignore: true}
									}, {
										title: EBContext.resource('NASTAVIT_MAX_MN') + '<br>(' + a.max_amount + ' ' + a.unit + ')',
										overrides: {package: 1, amount: a.max_amount, direct: true},
										selected: true
									}];
									break;
								case 'PRODUKT_NENALEZEN':
								case 'MSG_INVALID_AMOUNT_ITEM_MAXED_OUT':
									fos = [{
										title: EBContext.resource('NEPRIDAVAT'),
										overrides: {ignore: true},
										selected: true
									}];
									break;
								case 'MSG_AMOUNT_UNAVAILABLE':
									fos = [{
										title: EBContext.resource('NEPRIDAVAT'),
										overrides: {ignore: true}
									}];
									if(a.max_amount && a.max_amount !== a.current_amount){
										fos.push({
											title: EBContext.resource('NASTAVIT_MAX_MN') + '<br>(' + a.max_amount + ' ' + a.unit + ')',
											overrides: {package: 1, amount: a.max_amount},
											selected: true
										});
									} else {
										fos[0].selected = true;
									}
									break;
								case 'MSG_ITEM_MISSING_STDBAL':
									fot = 'select';
									fos.push({
										title: ' --- ',
										novalue: true,
										selected: true,
										disabled: true
									});
									a.availStdBal.forEach(sb=>{
										if(sb[0]==="*") sb = sb.substr(1);
										let an = parseFloat(sb);
										let disabled = ((a.amount*10000) % (an*10000) !== 0);
										fos.push({
											title: sb + (a.unit ? ' ' + a.unit : '') + (disabled ? ' (' + EBContext.resource('STDBAL_NEPLATNE_MNOZSTVI') + ')' : ''),
											overrides: {stdbal: sb},
											disabled: disabled
										});
									});
									if(!fos.find(a=>!a.disabled)){
										fos.push({
											title: EBContext.resource('NEPRIDAVAT'),
											overrides: {ignore: true}
										});
									}
									break;
								case 'MSG_ITEM_MISSING_PRIPRAVA':
									fot = 'select';
									fos.push({
										title: ' --- ',
										novalue: true,
										selected: true,
										disabled: true
									});
									Object.entries(zpusobyPripravy).forEach(ent=>{
										fos.push({
											title: ent[1],
											overrides: {priprava: ent[0]}
										});
									});
									if(!fos.find(a=>!a.disabled)){
										fos.push({
											title: EBContext.resource('NEPRIDAVAT'),
											overrides: {ignore: true}
										});
									}
									break;
								case 'MSG_ITEM_MISSING_STDBAL_PRIPRAVA':
									fot = 'select';
									fos.push({
										title: ' --- ',
										novalue: true,
										selected: true,
										disabled: true
									});
									a.availStdBal.forEach(sb=>{
										if(sb[0]==="*") sb = sb.substr(1);
										let an = parseFloat(sb);
										let disabled = ((a.amount*10000) % (an*10000) !== 0);
										fos.push({
											title: sb + (a.unit ? ' ' + a.unit : '') + (disabled ? ' (' + EBContext.resource('STDBAL_NEPLATNE_MNOZSTVI') + ')' : ''),
											overrides: {stdbal: sb},
											disabled: disabled,
											optgroup: 'STDBAL' 
										});
									});
									Object.entries(zpusobyPripravy).forEach(ent=>{
										fos.push({
											title: ent[1],
											overrides: {priprava: ent[0]},
											optgroup: 'ZPUSOB_PRIPRAVY'
										});
									});
									if(!fos.find(a=>!a.disabled)){
										fos.push({
											title: EBContext.resource('NEPRIDAVAT'),
											overrides: {ignore: true}
										});
									}
							}
							let foHtml = '';
							if(fot==='select'){
								let foArr = [];
								let fog;
								fos.sort((a,b)=>(a.optgroup > b.optgroup ? 1 : (a.optgroup < b.optgroup ? -1 : 0)));
								for(j = 0; j<fos.length;j++){
									let fo = fos[j];
									if(fo.optgroup !== fog){
										if(fog) foArr.push('</optgroup>');
										if(fo.optgroup) foArr.push('<optgroup label="' + EBContext.resource(fo.optgroup).replace(/\"/g,'&'+'quot;') + '">');
										fog = fo.optgroup;
									}
									foArr.push('<option value="' + (fo.novalue ? '' : JSON.stringify(fo.overrides).replace(/\"/g,'&'+'quot;'))+'"'+(fo.selected ? ' selected' : '')+(fo.disabled ? ' disabled' : '')+'>'+fo.title+'</option>');
								}
								if(fog) foArr.push('</optgroup>');
								let optionsHTML = foArr.join('');
								if(optionsHTML) foHtml = '<select class="form-select w-100 mt-2" name="'+a._id+'_'+i+'" required autocomplete="off">'+optionsHTML+'</select>';
							} else {
								let fbArr = [];
								for(j = 0; j<fos.length;j++){
									let fo = fos[j];
									fbArr.push('<input type="radio" class="btn-check" required value="' + (fo.novalue ? '' : JSON.stringify(fo.overrides).replace(/\"/g,'&'+'quot;'))+'" name="'+a._id+'_'+i+'" id="'+a._id+'_'+i+'_'+j+'" autocomplete="off"'+(fo.selected ? ' checked' : '')+(fo.disabled ? ' disabled' : '')+'><label class="mt-2 btn btn-outline-'+alertClassMap[m.type]+' col d-flex align-items-center justify-content-center" for="'+a._id+'_'+i+'_'+j+'">'+fo.title+'</label>');
								}
								let buttonsHTML = fbArr.join('');
								if(buttonsHTML) foHtml = '<div class="row m-0" role="group">' + buttonsHTML + '</div>';
							}
							msgTemplate = '<div class="alert alert-'+alertClassMap[m.type]+' p-2 mb-0 mt-2"><div class="d-flex"><div><i class="fas fa-fw fa-2x me-2 mt-1 fa-'+iconMap[m.type]+'"></i></div><div>'+EBContext.resource(m.message)+'</div></div>'+foHtml+'</div>';
							itemTemplate += msgTemplate;
						}
					}
					return itemTemplate;
				},
				fnProcessForm: (e,el, opt)=>{
					let overrides = Object.entries(EBContext.utils.serializeForm(el, true));
					items = opt.items.filter(item=>!item.ok);
					items.forEach(item=>{
						let itemOverrides = overrides.filter(o=>o[0].indexOf(item._id)===0).map(o=>JSON.parse(o[1]));
						item = EBContext.utils.extendObj.apply(null, [false, item].concat(itemOverrides));
						delete item.basketItems;
						delete item.message;
						delete item.ok;
						delete item.status;
						delete item[''];
						delete item._id;
						if(item.oid) delete item.search;
						if(item.hasOwnProperty('basketpol')) delete item.basket_items; // kdy� je vypln�n� "basketpol", tak u� je vybran� konkr�tn� polo�ka ko��ku, a tedy nep�ed�vat polo�ky k v�b�ru v "basket_items"
					});
					items.filter(item=>item.ignore).forEach(item=>{
						let amountEl = document.querySelector('.basketItem[data-oid="' + item.basketpol + '"] input[name="amount"]');
						if(amountEl) amountEl.value = amountEl.getAttribute('data-amount-check');
					});
					items = items.filter(item=>!item.ignore);
					if(!items.length){ 
						// console.debug('DEBUG - �e�en� konflikt� ko��ku - NEPRIDAVAT zb�vaj�c� polo�ky', items);
						// u� nejsou ��dn� konflikty, tak zavolat callback / p�ej�t do ko��ku
						if(opt.callback && 'function' === typeof opt.callback) opt.callback(items, options);
					} else {
						// console.debug('DEBUG - �e�en� konflikt� ko��ku - odesl�n� �e�en� polo�ek: ', items);
						// odeslat �e�en� zb�vaj�c�ch konflikt�
						if(opt.action==='update'){
							self.basket.update(items, opt.callback);
						} else {
							self.basket.add(items, null, opt.callback);
						}
					}
					EBContext.modal.get(el).close();
					e.preventDefault();
					e.stopPropagation();
					return false;
				},
				fnClose: (e, el)=>{
					let modal = EBContext.modal.get(el);
					if(modal) modal.close(true);
				}
			})[0];
			/*let i, renderItem = function(item){
				
			};
			for(i=0;i<items.length;i++) renderItem(items[i]);*/
			EBContext.popup(resolvePopup, {modal: true, disposeOnClose: true});
			return true;
		},
		processResponse: function (response, options) {
			// parse JSONStringu response
			if(!EBContext.utils.isPlainObj(response) && !Array.isArray(response)){
				try {
					response = JSON.parse(response);
				} catch (e) {
					console.error(e, response);
					return false;
				}
			}
			if(Array.isArray(response)) response = {items: response};
			// console.debug('DEBUG - zpracov�n� odpov�di. Polo�ky: ', response.items);
			if(response.hasOwnProperty('error')){
				EBContext.alert(response.error.message + "<br><pre>" + response.error.data + "</pre>", null, {heading: response.error.heading});
				return false;
			}
			
			let oldItems = self.basket.items;
			
			// basket.load - update basketItems podle dump loadBasket
			if(response.hasOwnProperty('dump')){
				if (response.dump.length < 2) {
					self.basket.items = [];
					self.basket.summary = {};
				} else {
					self.basket.summary = response.dump.splice(-1, 1)[0];
					self.basket.items = response.dump;
				}
				self.basket.loaded = true;
				self.basket.renderers.forEach(r => r({
					summary: self.basket.summary,
					items: self.basket.items
				}));
			}
			// basket.add/update - zpracovat a zobrazit v�sledek akc�
			if(response.items && !Array.isArray(response.items)) response.items = Object.values(response.items);
			if(response.items && response.items.length){
				let items = response.items.filter(bi=>bi.ok).map(bi=>bi.oid);
				let remainingGoods = self.basket.items.filter(bi=>!items.includes(bi.OID)).map(bi=>bi.Good);
				let rmGoods = oldItems.map(bi=>bi.Good).filter(gOID=>!remainingGoods.includes(gOID));
				
				// p�idat stav ko��ku u good�, kter� jsou na n�jak� polo�ce ko��ku
				// odebrat stav ko��ku u good�, kter� u� nemaj� v ko��ku ��dn� BasketItem
				bUpdateState = false;
				response.items.forEach(bi=>{
					if(!bi.ok){ // Data se nem�n�, tak rollbacknout zm�ny ve str�nce bez reloadu
						let biAmounts = document.querySelectorAll('.basketItem[data-oid="' + bi.basketpol + '"] .basketAmount');
						[...biAmounts].forEach(el=>{
							el.value = bi.current_amount || bi.amount;
						});
					} else {
						bUpdateState = true;
					}
				});				
				if(bUpdateState){
					updateState('basket', remainingGoods, true);
					updateState('basket', rmGoods, false, true, ()=>EBContext.async.finish('basketUpdate'));
				}
				if (EBContext.tabSync){
					EBContext.tabSync.update('basket', {oid: remainingGoods, state: true});
					EBContext.tabSync.update('basket', {oid: rmGoods, state: false});
				}

				if(!response.items.filter(bi=>!bi.ok).length){
					let messageTypes = {
						OK: 'success',
						WARN: 'warning',
						ERR: 'error'
					};
					let j;
					// @TODO - p�ed�lat textov� notifikace na dla�dice s obr�zkem, n�zvem a mno�stv�m
					for (i = 0; i < response.items.length; i++) {
						if(response.items[i].message){
							for (j = 0; j < response.items[i].message.length; j++) {
								EBContext.session.notify(EBContext.resource(response.items[i].message[j].message), messageTypes[response.items[i].message[j].type]);
							}
						}
					}
					if(options && 'function' === typeof options.callback && options.callback !== self.basket.processResponse) options.callback(response, options);
					self.basket.processAnalytics({oldItems: oldItems, response: response, options: options});
					return true;
				} else {
					options.zpusobyPripravy = response.zpusobyPripravy || {};
					self.basket.resolve(response.items, options);
				}
			} else if(response.message){
				let m = response.message;
				let alertClassMap = {ERR: 'danger', WARN: 'warning', OK: 'success'};
				let iconMap = {ERR: 'times-circle', WARN: 'exclamation-triangle', OK: 'check-square'};
				let headingMap = {ERR: 'CHYBA', WARN: 'POZOR', OK: 'USPECH'};
				let msgTemplate = '<div class="alert alert-'+alertClassMap[m.type]+' p-2 mb-0 mt-2"><div class="d-flex"><div><i class="fas fa-fw fa-2x me-2 mt-1 fa-'+iconMap[m.type]+'"></i></div><div>'+EBContext.resource(m.message)+'</div></div></div>';
				EBContext.alert(msgTemplate, null, {heading: EBContext.resource(headingMap[m.type])});
			}
		},
		processAnalytics: function(e){
			if(!EBContext.analytics || !e.options || !e.options.action) return;
			let eventName, eventData;
			// eventData = Object.values(Object.fromEntries(Object.entries(response.items).map(ent => [ent[0], EBContext.analytics.tryGetItem('basket_item', ent[1].basketpol)])));
			switch (e.options.action) {
				case 'addGood':
				case 'addBasket':
				case 'addDocument':
				case 'importBasket':
					eventName = 'add_to_cart';
					eventData = Object.values(Object.fromEntries(Object.entries(e.response.items).map(ent =>[ent[0], {
						jsonItem: EBContext.analytics.tryGetItem('basket_item', ent[1].basketpol),
						basketItem: self.basket.items.find(bi=>bi.OID===ent[1].basketpol),
						responseItem: ent[1],
						dumpItem: e.response.dump.reverse().find(di=>di.OID===ent[1].basketpol) || e.response.dump.reverse().find(di=>(ent[1].basketpol === "*" && di.Good === ent[1].oid && di.Amount === ent[1].amount))
					}])));
					break;
				case 'updateItems':
					eventName = 'update_shopping_cart';
					eventData = Object.values(Object.fromEntries(Object.entries(e.response.items).map(ent =>[ent[0], {
						jsonItem: EBContext.analytics.tryGetItem('basket_item', ent[1].basketpol),
						basketItem: self.basket.items.find(bi=>bi.OID===ent[1].basketpol),
						responseItem: ent[1],
						dumpItem: e.response.dump.reverse().find(di=>di.OID===ent[1].basketpol) || e.response.dump.reverse().find(di=>(ent[1].basketpol === "*" && di.Good === ent[1].oid && di.Amount === ent[1].amount)),
						oldItem: e.oldItems.find(oi=>oi.OID===ent[1].basketpol)
					}])));
					break;
				case 'removeItems':
				case 'removeGood':
				case 'emptyBasket':
					eventName = 'remove_from_cart';
					eventData = Object.values(Object.fromEntries(Object.entries(e.response.items).map(ent =>{
						let responseItem = EBContext.utils.extendObj(false, ent[1], {
							amount: e.oldItems.find(oi=>oi.OID===ent[1].basketpol).Amount || 0 // Odebran� mno�stv�
						});
						return [ent[0], {
							jsonItem: EBContext.analytics.tryGetItem('basket_item', ent[1].basketpol),
							basketItem: self.basket.items.find(bi=>bi.OID===responseItem.basketpol),
							responseItem: responseItem,
							dumpItem: e.response.dump.reverse().find(di=>di.OID===responseItem.basketpol) || e.response.dump.reverse().find(di=>(responseItem.basketpol === "*" && di.Good === responseItem.oid && di.Amount === responseItem.amount)),
							oldItem: e.oldItems.find(oi=>oi.OID===responseItem.basketpol)
						}];
					})));
					break;
				case 'saveBasket':
					eventName = 'save_shopping_cart';
					eventData = {
						name: e.name,
						response: e.response,
						items: self.basket.items.map(item=>{ return {basketItem: item} })
					};
					break;
				case 'deleteBasket':
					eventName = 'delete_shopping_cart';
					eventData = e;
					break;
				default: // loadBasket
					eventName = 'load_shopping_cart';
					eventData = e;
			}
			EBContext.analytics.fire(eventName, eventData);	
		},
		checkAmount: function (inputAmount, fix) {
			let step, min, max, am, ok;
			fix = fix || false;
			
			let pkgEl = inputAmount.closest(self.options.productWrapSelector).querySelector('[name=package]');
			
			step = parseFloat(inputAmount.getAttribute('step')) || null;
			max = parseFloat(inputAmount.getAttribute('max')) || null;
			min = parseFloat(inputAmount.getAttribute('min')) || step || 0;
			pkg = (pkgEl ? parseFloat(pkgEl.value) : null) || 1;
			am = parseFloat(inputAmount.value) || min;
			ok = true;
			
			if (isNaN(am)) {
				self.notify(EBContext.resource('INVALID_AMOUNT'), 'warning');
				if (fix) inputAmount.value = min;
				ok = false;
			} else if (am < min) {
				require(['notifyjs'], () => $(inputAmount).notify(EBContext.resource('MSG_BASKET_ADD_MIN').replace('#MIN#', min), {
					className: 'warning'
				}));
				if (fix) inputAmount.value = min;
				ok = false;
			} else if (max !== null && am * pkg > max) {
				require(['notifyjs'], () => $(inputAmount).notify(EBContext.resource('MSG_BASKET_ADD_MAX').replace('#MAX#', max), {
					className: 'warning'
				}));
				if (fix) inputAmount.value = max;
				ok = false;
			} else if (step && am && (am*10000) % (step*10000) > 0) {
				require(['notifyjs'], () => $(inputAmount).notify(EBContext.resource('MSG_BASKET_ADD_STEP').replace('#STEP#', step), {
					className: 'warning'
				}));
				if (fix) inputAmount.value = Math.ceil(am / step) * step;
				ok = false;
			}
			let selEl = inputAmount.closest(self.options.productWrapSelector).querySelector('[name=selected]');
			if (selEl) selEl.checked = (ok && parseFloat(inputAmount.value) > 0);
			// if(!ok && !fix) - @TODO - doplnit grafickou invalidaci inputu, a n�slednou revalidaci...
			return ok;
		},
		select: function (selectEl) {
			let inputEl = selectEl.closest('.product').querySelector('[name="amount"]');
			if (selectEl.checked) {
				if (inputEl.value == '0') {
					inputEl.value = parseFloat(inputEl.getAttribute('min')) || parseFloat(inputEl.getAttribute('step')) || 1;
				}
			} else {
				inputEl.value = 0;
			}
		},
		addBasket: function (oid, clearBasket) {
			if (self.basket.items.length > 0 && typeof clearBasket === 'undefined') {
				return EBContext.confirm(EBContext.resource('MSG_KOSIK_NENI_PRAZDNY'), resp => self.basket.addBasket(oid, resp), {
					heading: EBContext.resource('KOSIK_NENI_PRAZDNY'),
					btnOK: {
						text: EBContext.resource('VYPRAZDNIT_KOSIK')
					},
					btnCancel: {
						text: EBContext.resource('PRIDAT_POLOZKY'),
						class: 'btn btn-block d-md-inline w-md-auto float-left btn-success mt-2 text-truncate'
					},
					btnEsc: {
						show: true
					},
					modal: false
				});
			}
			EBContext.async.start('basketToBasket');
			EBContext.ajaxNav.call(self.options.basket.moduleBlock + '.LoadSavedBasket', (response, options)=> {
				self.basket.processResponse(response, {action:'addBasket', callback: () => EBContext.async.finish('basketToBasket')});
			}, 'basketOID=' + oid + (clearBasket ? '&clearBasket=1' : ''), self.options.basket.updateURL);
		},
		addDocument: function (doc, clearBasket) { // nap�.: Objednavka_Prodej.0500000023
			if (self.basket.items.length > 0 && typeof clearBasket === 'undefined') {
				return EBContext.confirm(EBContext.resource('MSG_KOSIK_NENI_PRAZDNY'), resp => self.basket.addDocument(doc, resp), {
					heading: EBContext.resource('KOSIK_NENI_PRAZDNY'),
					btnOK: {
						text: EBContext.resource('VYPRAZDNIT_KOSIK')
					},
					btnCancel: {
						text: EBContext.resource('PRIDAT_DO_KOSIKU'),
						class: 'btn btn-block d-md-inline w-md-auto float-left btn-success mt-2 text-truncate'
					},
					btnEsc: {
						show: true
					},
					modal: false
				});
			}
			EBContext.async.start('documentToBasket');
			let methodName;
			let docArr = (doc + '.').split('.');
			switch (docArr[0].toLowerCase()) {
				case 'objednavka_prodej':
					methodName = 'CopyToBasket';
					break;
				case 'nabidka_prodej':
					methodName = 'OfferToBasket';
					break;
				default:
					console.error('Unknown document type!');
					break;
			}
			EBContext.ajaxNav.call(self.options.basket.moduleBlock + '.' + methodName, (response, options)=> {
				self.basket.processResponse(response, {action:'addDocument', callback: () => EBContext.async.finish('documentToBasket')});
			}, 'docOID=' + docArr[1] + (clearBasket ? '&clearBasket=1' : ''), self.options.basket.updateURL);
		},
		updateAmount: function (selectPackage) {
			let amountEl = selectPackage.closest(self.options.productWrapSelector).querySelector('[name=amount]');
			let baseAmount = parseFloat(selectPackage.getAttribute('data-baseamount') || '1');
			let selectedEl = selectPackage.closest(self.options.productWrapSelector).querySelector('[name=selected]');
			let packageAmount = parseFloat(selectPackage.value || '1');
			if(baseAmount > 0){
				let pkgStep = ((baseAmount*10000) / (packageAmount*10000));
				let pkgStep2 = pkgStep*10000;
				if(Math.trunc(pkgStep2) !== pkgStep2) pkgStep = 1;
				amountEl.step = pkgStep;
				// amountEl.value = pkgStep;
				/* 
				 * Pokud u�ivatel hodnotu inputu zm�nil p�ed zm�nou balen�, a zadan� hodnota je v r�mci balen� validn�, tak ji nem�nit.
				 * Pokud validn� nen�, nebo jde o v�choz� hodnotu, tak nastavit cel� balen�.
				 * Pokud jedno cel� balen� nen� d�liteln� jednotkov�m mno�stv�m, tak nastavit jednotkov� mno�stv�.
				 */
				if(amountEl.value === amountEl.min || (parseFloat(amountEl.value)*10000) % pkgStep2 > 0){
					amountEl.value = 1;
					if(10000 % (pkgStep*10000) > 0) amountEl.value = pkgStep;
				}
				if(!selectedEl) amountEl.min = pkgStep;
			} else {
				amountEl.step = 'any';
				amountEl.value = 1;
				amountEl.min = 0;
			}
		},
		save: function (basketName) {
			if (!basketName) {
				EBContext.prompt(EBContext.resource('ZADEJTE_NAZEV_KOSIKU') + ': ', function (resp) {
					if (resp !== null) {
						if (!resp) resp = '&nbsp;';
						self.basket.save(resp);
					}
				}, {
					heading: EBContext.resource('ULOZIT_KOSIK')
				});
			} else {
				EBContext.ajaxNav.call(self.options.basket.moduleBlock + '.SaveBasket', function (response) {
					self.basket.processAnalytics({name: basketName, response: response, options: {action: 'saveBasket'}});
					EBContext.confirm(EBContext.resource('MSG_KOSIK_BYL_ULOZEN').replace(/#KOSIK#/g, basketName) + '<br>' + EBContext.resource('MSG_ZOBRAZIT_ULOZENE_KOSIKY'), function (resp) {
						if (resp) EBContext.ajaxNav.navigationTrigger('/baskets');
					}, {
						heading: EBContext.resource('KOSIK_BYL_ULOZEN')
					});
				}, 'basketName=' + basketName, self.options.basket.updateURL);
			}
		},
		delete: function (oid, confirmed) {
			if (!confirmed) {
				EBContext.confirm(EBContext.resource('OPRAVDU_SMAZAT_KOSIK'), function (resp) {
					if (resp) self.basket.delete(oid, resp);
				}, {
					heading: EBContext.resource('SMAZAT_KOSIK')
				});
			} else {
				EBContext.ajaxNav.call('$BASKETS.DeleteBasket', function (resp) {
					self.basket.processAnalytics({oid: oid, options: {action: 'deleteBasket'}});
					EBContext.ajaxNav.navigationTrigger(null, null, null, {
						navigation: false
					});
					if (typeof resp === 'boolean' && resp) {
						EBContext.session.notify(EBContext.resource('MSG_KOSIK_BYL_SMAZAN'), {
							className: 'warning'
						});
					} else {
						console.error(resp);
					}
				}, 'basketOID=' + oid);
			}
		}
	};
	this.favorite = {
		items: [],
		add: function (oid) {
			EBContext.ajaxNav.call('$LOGIN.setFavorite', resp => {
				if (resp) {
					let state = (resp.toString().indexOf(oid) > -1);
					updateState('favorite', oid, state, true);
					if (EBContext.tabSync) EBContext.tabSync.update('favorite', {
						oid: oid,
						state: state
					});
				}
			}, null, null, {
				good: oid
			});
		},
		remove: function (oid) {
			EBContext.ajaxNav.call('$LOGIN.setFavorite', resp => {
				if (resp) {
					let state = (resp.toString().indexOf(oid) > -1);
					updateState('favorite', oid, state, true);
					if (EBContext.tabSync) EBContext.tabSync.update('favorite', {
						oid: oid,
						state: state
					});
				}
			}, null, null, {
				good: '*' + oid
			});
		}
	};
	this.compare = {
		items: [],
		add: function (oid) {
			setState('compare', oid, true, 'addGoodCompare=' + oid);
		},
		remove: function (oid) {
			setState('compare', oid, false, 'removeGoodCompare=' + oid);
		}
	};

	// @TODO - je pot�eba upravit v modLOGIN a modGOODRESULT a� se n�jak standardizuje, a zbav�me se USER modulu
	this.watchdog = {
		items: [],
		add: function (oid, postParams) {
			setState('watchdog', oid, true, 'good=' + oid, postParams);
		},
		update: function (oid, postParams) {
			setState('watchdog', oid, true, 'good=' + oid, postParams);
		},
		remove: function (oid) {
			setState('watchdog', oid, false, 'good=' + oid);
		}
	};

	this.init(options);
	self.keepAlive.init();

	// self.cookie.register({
	// 	id: 'eb_session',
	// 	name: EBContext.resource('SESSION_ID'),
	// 	description: EBContext.resource('MSG_COOKIES_SESSION_DESCRIPTION'),
	// 	reasons: ['login', 'analytics'],
	// 	callback: resp => {
	// 		if (!resp) {
	// 			self.cookie.clear();
	// 			window.location.href = 'https://google.com';
	// 		}
	// 	}
	// });
	
	document.addEventListener('EBContext.ajaxNav.bodyReload', ()=>self.basket.loaded=false);
	document.addEventListener('EBContext.tabSync.update', function () {
		let updates = EBContext.tabSync.updates;
			
		/**
		 * Zpracov�n� login/logout - obnoven� ostatn�ch z�lo�ek
		 */
		let userChanged = false;
		if (updates.hasOwnProperty('userId')) {
			if(updates.userId.length){
				let newUserId = updates.userId[updates.userId.length-1] || '';
				let currentUserId = EBContext.session.user.id || '';
				if(newUserId!==currentUserId){
					userChanged = true;
					EBContext.confirm(
						EBContext.resource("MSG_ZMENA_PRIHLASENI_RELOAD"), 
		 				resp=>{if(resp) EBContext.ajaxNav.navigationTrigger()}, 
		 				{heading: EBContext.resource("DOSLO_K_PRIHLASENI")}
		 			);
				}
				EBContext.tabSync.updates.userId = [];
			}
		}
	
		/**
		 * Zpracov�n� favorites, watchdog, compare a basket
		 */
		if(!userChanged){
			let i, types, type, typeData, product;
			let presentTypes = [];
			
			types = ['favorite', 'watchdog', 'compare', 'basket'];
			for (i = 0; i < types.length; i++) {
				type = types[i];
				if (!updates.hasOwnProperty(type)) continue;
				presentTypes.push(type);
				typeData = updates[type];
				while (typeData.length) {
					product = typeData.shift();
					self.options.statusUpdate(type, product.oid, product.state);
				}
				if(typeof self.options[type].tabSyncCallback === 'function') self.options[type].tabSyncCallback();
			}
			EBContext.tabSync.reload(getReloadBlocks(presentTypes)); // p�id� bloky k reloadu
		}
	});
	self.redirect.add('EBContext.session.login','/kosik/','/kosik/.+');
	document.addEventListener('EBContext.ajaxNav.navigated', function () {
		let self = EBContext.session;
		let basketItems = self.basket.items.map(i=>i.Good);
		// console.log(basketItems);
		self.options.statusUpdate('basket', '*', false);
		self.options.statusUpdate('basket', basketItems, true);
		
		// TODO: Favorites a Compare se do pole items zat�m neukl�daj�!
		// let favoriteItems = self.favorite.items;
		// self.options.statusUpdate('favorite', '*', false);
		// self.options.statusUpdate('favorite', favoriteItems, true);
		
		// let compareItems = self.compare.items;
		// self.options.statusUpdate('compare', '*', false);
		// self.options.statusUpdate('compare', basketItems, true);
	});
	EBContext.actions.cookiesPopup = self.cookie.showSettings;
	EBContext.actions.setLanguage = self.user.setLanguage;
	EBContext.actions.setCurrency = self.user.setCurrency;
	EBContext.actions.setLocale = self.user.setLocale;
	EBContext.actions.setPrices = self.user.setPrices;

	if (EBContext.options.cookies !== false) EBContext.ajaxNav.ready(self.cookie.check);
	if (EBContext.options.basket !== false) EBContext.ready(() => {
		document.addEventListener('EBContext.ajaxNav.bodyReloaded', ()=>{if(!self.basket.loaded){self.basket.load()}});
		// document.addEventListener('EBContext.session.login', self.basket.load); // Zak�zat" - p�i loginu prob�h� reload BODY, tak se potom ko��k na��t� dvakr�t!
		self.basket.load();
	});
	return this;
};

/** Nen� pot�eba vkl�dat do shims, sta�� na��st a� te� - s jednou z�lo�kou to nem� smysl, a p�i otev�en� druh� u� to bude sta�en� **/
require(['EBContext_TabSync']); // loader se na��t� jen pro zrychlen� p�ed provn�m pou�it�m - nap�. vkl�d�n� produktu do ko��ku...

EBContext.session = new EBContext.modules.SessionUtils(EBContext.config.session);
// EBContext.keepAlive = EBContext.session.keepAlive;
// EBContext.cookies = EBContext.session.cookie;

var showWatchdog = function (seoid) {
	EBContext.popup(self.options.watchdog.updateURL + seoid + '?skipHead=1');
	return false;
};
var watchdogCallback = function (oid, response) {
	if (window.location.pathname == self.options.watchdog.listURL || window.location.pathname.slice(0, 13) == self.options.watchdog.updateURL) {
		EBContext.AjaxNavigation.navigationTrigger(window.location.pathname, EBContext.utils.createAjaxURL(window.location.pathname));
	} else if (response == '0' || response == '1') {
		var i;
		var goodElements = document.querySelectorAll('[data-good-oid="' + oid + '"]');
		if (response == '0') {
			for (i = 0; i < goodElements.length; i++) {
				goodElements[i].querySelector('.watchdog-add').style.display = '';
				goodElements[i].querySelector('.watchdog-remove').style.display = 'none';
			}
			self.notify(EBContext.resource('MSG_WATCHDOG_DEAKTIVOVAN'), 'warning');
		} else {
			for (i = 0; i < goodElements.length; i++) {
				goodElements[i].querySelector('.watchdog-add').style.display = 'none';
				goodElements[i].querySelector('.watchdog-remove').style.display = '';
			}
			self.notify(EBContext.resource('MSG_WATCHDOG_AKTIVOVAN'), 'success');
		}
	} else {
		console.log(response);
		self.notify(EBContext.resource('MSG_WATCHDOG_ERROR'), 'error');
	}
	if (typeof Storage !== 'undefined') {
		localStorage.setItem('actionSync', JSON.stringify({
			'action': 'watchdog',
			'OID': oid,
			'active': response
		}));
	}
	// @TODO - doplnit zav�r�n� okna popupu
};